import { Grid } from "@mui/material";
import { action, API, controller } from "api";
import { Button, InputPass } from "controls";
import { Model, ToFormData, UseForm } from "hooks";
import { Alert, Form } from "layout";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PassValidation } from "utils";

const ResetPasswordForm = ({ setShowForm, userId }) => {
  const { PassResetMdl } = Model();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const {
    values,
    setValues,
    errors,
    passValid,
    setErrors,
    handleInpPass,
    resetFormControls,
  } = UseForm(PassResetMdl);

  useEffect(() => {
    setValues((j) => ({ ...j, userId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleClose = () => {
    resetFormControls();
    setShowForm(false);
  };

  const validateForm = () => {
    let temp = {};
    temp.userId = values.userId !== "" ? "" : "UserId not found";
    temp.newPassword = values.newPassword !== "" ? "" : "Password is required";
    temp.confirmPassword =
      values.confirmPassword !== ""
        ? values.confirmPassword === values.newPassword
          ? ""
          : "Password and Confirm password not match"
        : "Confirm password is required";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      API(controller.User + action.ResetPassword).post(
        ToFormData(values),
        (res) => {
          setLoading(false);
          if (res?.status === 200) {
            handleClose();
            toast.success(res?.msg);
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: "Error",
              subTitle: res?.msg,
            });
        }
      );
    }
  };

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2} className="p-[10px] pt-[30px]">
          <Grid item xs={12}>
            <div className="text-center">
              <span className="text-[22px] uppercase font-medium ml-[5px] text-gray-500">
                Reset Password
              </span>
              <div className="bs-bottom max-w-[80px] m-auto mt-[10px] mb-[30px]" />
            </div>
          </Grid>
          {errors.userId && (
            <Grid item xs={12}>
              <span className="text-red-500 pl-[5px]">
                * {errors.userId} Jihad
              </span>
            </Grid>
          )}
          <Grid item xs={12}>
            <InputPass
              label={"New Password"}
              name="newPassword"
              value={values.newPassword}
              onChange={handleInpPass}
              error={errors.newPassword}
              className="input-primary w-100pr"
              size="large"
            />
            {values.newPassword && (
              <PassValidation
                {...{ newPassword: values.newPassword, passValid }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <InputPass
              label={"Confirm Password"}
              name="confirmPassword"
              value={values.confirmPassword}
              onChange={(e) => handleInpPass(e, true)}
              error={
                errors.confirmPassword !== "" &&
                values.newPassword !== "" &&
                !passValid.match &&
                values.confirmPassword !== ""
                  ? "Password and confirm password not match"
                  : errors.confirmPassword
              }
              className="input-primary w-full"
              size="large"
            />
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} md={6}>
            <Button onClick={handleClose} fullWidth variant="text" size="large">
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button type="submit" loading={loading} fullWidth size="large">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Form>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default ResetPasswordForm;
